export default __webpack_public_path__ + "static/media/scrollTooltip.b5318849.png";